import { NuxtAxiosInstance } from '@nuxtjs/axios';

export default ($axios: NuxtAxiosInstance) => ({
    get() {
      return $axios.get('/api/settings');
    },
  });